import React, { useState, useEffect } from "react";
import Category from "../components/Category";
import HeroSlide from "../components/HeroSlide";
import ProductSlide from "../components/ProductSlide";
import axios from "axios";
import { baseurl, imgurl } from "../baseurl"; // Ensure imgurl is imported
import CategoryMobile from "../components/CategoryMobile";
import ProductCardSlideMobile from "./HomeCompo/ProductCardSlideMobile";

function Privacy() {
  
    return (
     <>
     
     <section className="container my-5">
        <h1>Privacy Policy</h1>
    <p><strong>Subcity International Marketing Pvt Ltd</strong></p>
    <p><strong>Effective Date:</strong> 02/02/2026<br/>
    <strong>Last Updated:</strong> 02/02/2026</p>

    <p>Subcity International Marketing Pvt Ltd (“Company”, “we”, “our”, “us”) is committed to protecting the privacy and personal data of users in accordance with applicable laws of India, including the Information Technology Act, 2000, IT (SPDI) Rules, 2011, Consumer Protection (E-Commerce) Rules, 2020, and the Digital Personal Data Protection Act, 2023 (DPDP Act).</p>
    
    <p>By accessing or using our e-commerce website, you agree to the terms of this Privacy Policy.</p>

    <hr/>

    <h2>1. Information We Collect</h2>
    
    <h3>a) Personal Information</h3>
    <ul>
        <li>Name</li>
        <li>Mobile number</li>
        <li>Email address</li>
        <li>Billing and shipping address</li>
    </ul>

    <h3>b) Order & Transaction Information</h3>
    <ul>
        <li>Product details</li>
        <li>Order history</li>
        <li>Payment transaction reference number</li>
    </ul>
    <p class="warning">⚠️ We do not store debit/credit card numbers, CVV, UPI PIN, or passwords.</p>

    <h3>c) Technical Information</h3>
    <ul>
        <li>IP address</li>
        <li>Browser and device details</li>
        <li>Cookies and website usage data</li>
    </ul>

    <h2>2. Purpose of Data Collection</h2>
    <p>We collect and use personal data only for lawful purposes, including:</p>
    <ul>
        <li>Processing and delivering orders</li>
        <li>Customer support and grievance handling</li>
        <li>Legal, tax, and regulatory compliance</li>
        <li>Fraud prevention and platform security</li>
        <li>Marketing communication (only with user consent)</li>
    </ul>

    <h2>3. Consent</h2>
    <ul>
        <li>Consent is obtained explicitly during registration or checkout</li>
        <li>Users may withdraw consent at any time by contacting us</li>
        <li>Withdrawal of consent may limit access to certain services</li>
    </ul>

    <h2>4. Cookies Policy</h2>
    <p>Our website uses cookies to:</p>
    <ul>
        <li>Enable secure login</li>
        <li>Remember preferences</li>
        <li>Improve website performance</li>
    </ul>
    <p>Users may disable cookies via browser settings, though some features may not function properly.</p>

    <h2>5. Data Sharing & Disclosure</h2>
    <p>We do not sell or rent personal data. Personal data may be shared only with:</p>
    <ul>
        <li>Courier and logistics partners (for delivery)</li>
        <li>RBI-authorized payment gateway providers</li>
        <li>Government or legal authorities when required by law</li>
    </ul>
    <p>All third parties are bound by confidentiality obligations.</p>

    <h2>6. Data Storage & Retention</h2>
    <ul>
        <li>Data is stored on secure servers located in India or legally permitted jurisdictions</li>
        <li>Personal data is retained only for the period required by law or business purpose</li>
        <li>Data is securely deleted after the retention period</li>
    </ul>

    <h2>7. Data Security</h2>
    <p>As required under Rule 8 of the IT (SPDI) Rules, we follow reasonable security practices, including:</p>
    <ul>
        <li>SSL encryption</li>
        <li>Access-controlled systems</li>
        <li>Internal data access restrictions</li>
        <li>Periodic security reviews</li>
    </ul>

    <h2>8. User Rights (DPDP Act, 2023)</h2>
    <p>Users have the right to:</p>
    <ul>
        <li>Access their personal data</li>
        <li>Request correction or deletion</li>
        <li>Withdraw consent</li>
        <li>Nominate another individual to exercise rights</li>
        <li>File a grievance with the Grievance Officer</li>
    </ul>

    <h2>9. Grievance Redressal Officer</h2>
    <p>As per Consumer Protection (E-Commerce) Rules, 2020:</p>
    <div class="contact-info">
        <strong>Grievance Officer:</strong> Md Helal Uddin<br/>
        <strong>Email:</strong> subcityinternational22@gmail.com<br/>
        <strong>Mobile:</strong> 8638407127
    </div>
    <p>⏱ Complaints will be acknowledged within 48 hours and resolved within 30 days.</p>

    <h2>10. Children’s Privacy</h2>
    <p>Our website is not intended for individuals below 18 years of age. If any such data is identified, it will be deleted immediately.</p>

    <h2>11. Third-Party Links</h2>
    <p>Our website may contain links to third-party websites. We are not responsible for the privacy practices or content of such websites.</p>

    <h2>12. Policy Updates</h2>
    <p>This Privacy Policy may be updated from time to time to reflect changes in law or business practices. Updated versions will be published on this page with a revised date.</p>

    <h2>13. Contact Details</h2>
    <div class="contact-info">
        <strong>Subcity International Marketing Pvt Ltd</strong><br/>
        📍 Address: Vill Paliguri, Jagiroad, Morigaon, Assam – 782410, India<br/>
        📞 Mobile: 8638407127<br/>
        📧 Email: subcityinternational22@gmail.com
    </div>


<style>
    {`
    <style>
        body {
            font-family: Arial, sans-serif;
            line-height: 1.6;
            color: #333;
            max-width: 800px;
            margin: 0 auto;
            padding: 20px;
        }
        h1, h2, h3 {
            color: #2c3e50;
        }
        .contact-info {
            background-color: #f9f9f9;
            padding: 15px;
            border-left: 5px solid #2c3e50;
            margin: 20px 0;
        }
        .warning {
            background-color: #fff3cd;
            padding: 10px;
            border-radius: 5px;
            display: inline-block;
        }
        ul {
            margin-bottom: 20px;
        }
    </style>
    `}
</style>
     </section>
     
     </> 
   
  );
}

export default Privacy;